import { render, staticRenderFns } from "./AssignOrder.vue?vue&type=template&id=143f1d0d&"
import script from "./AssignOrder.vue?vue&type=script&lang=js&"
export * from "./AssignOrder.vue?vue&type=script&lang=js&"
import style0 from "./AssignOrder.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports